import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

export default async function validateOnground({
  code,
  eventId,
  tiers,
  slotId = null,
  ticketQuantity = 1,
  purchaseType = "onground",
  customerEmail = "",
}) {
  const body = {
    code,
    event: eventId,
    tiers,
    ticketQuantity,
    purchaseType,
  };
  if (slotId != null && slotId !== "") {
    body.slotId = slotId;
  }
  if (customerEmail) {
    body.customerEmail = customerEmail;
  }
  const { data } = await axios.post(
    routes.validateOngroundVoucher,
    body,
    AXIOS_DEFAULT_CONFIG
  );
  return data;
}
